export default {
  state: {
    modelViewUidList: sessionStorage.getItem('tree-uid-list') ? sessionStorage.getItem('tree-uid-list') : '',
    uId: sessionStorage.getItem('eid-uid') ? sessionStorage.getItem('eid-uid') : '',
    modelAllUidList: sessionStorage.getItem('model-uid-list') ? sessionStorage.getItem('model-uid-list') : ''
  },
  mutations: {
    SET_MODEL_UID_LIST(state, modelViewUidList) {
      state.modelViewUidList = modelViewUidList;
      sessionStorage.setItem('tree-uid-list', modelViewUidList);
    },
    SET_EID_UID(state, uId) {
      state.uId = uId;
      sessionStorage.setItem('eid-uid', uId);
    },
    SET_MODEL_LIST_VIEW(state, modelAllUidList) {
      state.modelAllUidList = modelAllUidList;
      sessionStorage.setItem('model-uid-list', modelAllUidList);
    }
  },
  actions: {
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/warehouse.js